// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.succese-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 20px;
}

/* Header */
.succese-header {
  text-align: center;
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.succese-trophy {
  font-size: 3.5rem;
  color: #f2c94c;

  text-shadow:
    2px 2px 0 black,
    -2px 2px 0 black,
    2px -2px 0 black,
    -2px -2px 0 black;

  filter: drop-shadow(0 4px 8px rgba(249,115,22,0.3));
}
.succese-header h1 {
  font-size: 2.5rem;
  font-weight: 900;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    2px 2px 0 black,
    -2px 2px 0 black,
    2px -2px 0 black,
    -2px -2px 0 black;
  margin:auto;
  line-height: 1;
}

.succese-header p {
  font-size: 1.05rem;
  font-weight: 900;
  font-family: 'Baloo 2', cursive;
  color: #000000; /* galben */
  margin:auto;
  line-height: 1;
}

.succese-counter {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff7ed;
  border: 2px solid #fed7aa;
  border-radius: 50px;
  padding: 10px 24px;
  font-size: 15px;
   color: #000000; /* galben */
  margin:auto;
  line-height: 1;
}
.succese-counter strong { font-size: 20px; }

/* Grid */
.succese-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

/* Card */
.succes-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1.5px solid #eee;
  box-shadow: 0 4px 16px rgba(0,0,0,0.07);
  transition: transform 0.2s, box-shadow 0.2s;
}
.succes-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.12);
}

/* Imagine */
.succes-imagine {
  position: relative;
}
.succes-imagine img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
.succes-no-image {
  width: 100%;
  height: 220px;
  background: #fff7ed;
  display: flex;
  align-items: center;
  justify-content: center;
}
.succes-badge {
  position: absolute;
  bottom: 12px;
  left: 12px;
  color: rgb(255, 255, 255);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

/* Info */
.succes-info {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.succes-titlu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.succes-titlu strong { font-size: 16px; }

.tip-badge {
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: 600;
}
.tip-badge.gasit { background: #dcfce7; color: #16a34a; }
.tip-badge.pierdut { background: #fee2e2; color: #dc2626; }

.succes-detalii {
  display: flex;
  gap: 14px;
  font-size: 13px;
  color: #888;
}
.succes-detalii span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.succes-mesaj {
  background: #f9fafb;
  border-left: 3px solid #000000;
  border-radius: 0 8px 8px 0;
  padding: 10px 14px;
  font-size: 13px;
  color: #444;
  line-height: 1.5;
  font-style: italic;
}
.ghilimele {
  color: #706800;
  font-size: 18px;
  font-weight: 800;
  font-style: normal;
}

.no-succese {
  text-align: center;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #aaa;
}
.no-succese small { font-size: 14px; }

.loading-text {
  text-align: center;
  padding: 60px;
  color: #999;
}

@media (max-width: 600px) {
  .succese-header h1 { font-size: 1.8rem; }
  .succese-grid { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/pages/SucceseFindMyPet.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;;EAEd;;;;qBAImB;;EAEnB,mDAAmD;AACrD;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;GACd,cAAc,EAAE,WAAW;EAC5B,WAAW;EACX,cAAc;AAChB;AACA,0BAA0B,eAAe,EAAE;;AAE3C,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,uBAAuB,eAAe,EAAE;;AAExC;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA,oBAAoB,eAAe,EAAE;;AAErC;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB,iBAAiB,EAAE;EACxC,gBAAgB,0BAA0B,EAAE;AAC9C","sourcesContent":[".succese-page {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n/* Header */\n.succese-header {\n  text-align: center;\n  margin-bottom: 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.succese-trophy {\n  font-size: 3.5rem;\n  color: #f2c94c;\n\n  text-shadow:\n    2px 2px 0 black,\n    -2px 2px 0 black,\n    2px -2px 0 black,\n    -2px -2px 0 black;\n\n  filter: drop-shadow(0 4px 8px rgba(249,115,22,0.3));\n}\n.succese-header h1 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    2px 2px 0 black,\n    -2px 2px 0 black,\n    2px -2px 0 black,\n    -2px -2px 0 black;\n  margin:auto;\n  line-height: 1;\n}\n\n.succese-header p {\n  font-size: 1.05rem;\n  font-weight: 900;\n  font-family: 'Baloo 2', cursive;\n  color: #000000; /* galben */\n  margin:auto;\n  line-height: 1;\n}\n\n.succese-counter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff7ed;\n  border: 2px solid #fed7aa;\n  border-radius: 50px;\n  padding: 10px 24px;\n  font-size: 15px;\n   color: #000000; /* galben */\n  margin:auto;\n  line-height: 1;\n}\n.succese-counter strong { font-size: 20px; }\n\n/* Grid */\n.succese-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n/* Card */\n.succes-card {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1.5px solid #eee;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.07);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n.succes-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 32px rgba(0,0,0,0.12);\n}\n\n/* Imagine */\n.succes-imagine {\n  position: relative;\n}\n.succes-imagine img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n}\n.succes-no-image {\n  width: 100%;\n  height: 220px;\n  background: #fff7ed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.succes-badge {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  color: rgb(255, 255, 255);\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n}\n\n/* Info */\n.succes-info {\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.succes-titlu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.succes-titlu strong { font-size: 16px; }\n\n.tip-badge {\n  font-size: 11px;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n.tip-badge.gasit { background: #dcfce7; color: #16a34a; }\n.tip-badge.pierdut { background: #fee2e2; color: #dc2626; }\n\n.succes-detalii {\n  display: flex;\n  gap: 14px;\n  font-size: 13px;\n  color: #888;\n}\n.succes-detalii span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.succes-mesaj {\n  background: #f9fafb;\n  border-left: 3px solid #000000;\n  border-radius: 0 8px 8px 0;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #444;\n  line-height: 1.5;\n  font-style: italic;\n}\n.ghilimele {\n  color: #706800;\n  font-size: 18px;\n  font-weight: 800;\n  font-style: normal;\n}\n\n.no-succese {\n  text-align: center;\n  padding: 80px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #aaa;\n}\n.no-succese small { font-size: 14px; }\n\n.loading-text {\n  text-align: center;\n  padding: 60px;\n  color: #999;\n}\n\n@media (max-width: 600px) {\n  .succese-header h1 { font-size: 1.8rem; }\n  .succese-grid { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
